module.exports = __webpack_public_path__ + "static/media/ios-compass.f82439ac.svg";